@if (!data$()) {
  <div class="sol-form-field-wrapper"></div>
} @else if (!isArray$()) {
  <!-- Single view -->
  <div class="sol-form-field-wrapper">
    <sol-view-host
      [data]="hostData$()!"
      [focused]="data$()!.focusIndex === 0"
      (value)="onHostValue($event)"
      (focused)="onHostFocused($event, 0)"
      (action)="onHostAction(0, $event)"
    />
    @if (showMessages$() && data$()!.messages?.length) {
      <sol-validation-messages [messages]="data$()!.messages!" />
    }
  </div>
} @else if (hasArrayView$()) {
  <!-- Registered array view -->
  <div class="sol-form-field-wrapper">
    <sol-view-host
      [data]="hostData$()!"
      [focused]="data$()!.focusIndex === 0"
      (value)="onHostValue($event)"
      (focused)="onHostFocused($event, 0)"
      (action)="onHostAction(0, $event)"
    />
    @if (showMessages$() && data$()!.messages?.length) {
      <sol-validation-messages [messages]="data$()!.messages!" />
    }
  </div>
} @else if (mode$() === 'edit') {
  <!-- Edit array view -->
  <div class="sol-form-field-array">
    @for (item of itemHostDatas$(); track item.index) {
      <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ item: item }" />
      <div class="sol-form-field-array-remove">
        @if (item.removable) {
          <sol-button [icon]="SolIcon.delete" [type]="SolButtonType.transparent" (click)="onRemove(item.index)" />
        }
      </div>
    }
    @if (canAdd$()) {
      <div class="sol-form-field-array-add">
        <sol-button [icon]="SolIcon.plus" (click)="onAdd()" />
      </div>
    }
  </div>
} @else {
  <!-- Read array view -->
  <div class="sol-form-field-array-readonly">
    @for (item of itemHostDatas$(); track item.index) {
      <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ item: item }" />
    }
  </div>
}

<ng-template #itemTemplate let-item="item">
  <div class="sol-form-field-wrapper">
    <sol-view-host
      [data]="item.hostData"
      [focused]="data$()!.focusIndex === item.index"
      (value)="onItemValue($event, item.index)"
      (focused)="onHostFocused($event, item.index)"
      (action)="onHostAction(item.index, $event)"
    />
    @if (showMessages$() && item.hostData.messages?.length) {
      <sol-validation-messages [messages]="item.hostData.messages!" />
    }
  </div>
</ng-template>
